/**
 * GraphQL errors whose class name the API sends as `extensions.domainError`, so a client branches
 * on a stable name instead of the human-readable message, which is free to be reworded. The
 * GraphQL counterpart of the tRPC `clientFacingErrors` registry: the backend checks every name
 * here against a real error class, so a rename there fails to compile rather than silently
 * breaking the branch on the client.
 *
 * Only names listed here are sent; any other error stays anonymous.
 */
export const graphQLClientFacingErrors = [
  'InvalidLoginCredentialsError',
  'Missing2FACodeError',
  'NotValid2FACodeError',
  'IpAddressNotAllowedError',
  'UserNotMigratedError',
  'UserHasNoPermissionsError',
  'InvalidIdpInStateError',
  'EmployeeNotInFaceUpError',
  'EmployeeNotActiveInFaceUpError',
  'MemberNotInFaceUpError',
  'NoKeysAfterSsoLoginError',
] as const

export type GraphQLDomainErrorName = (typeof graphQLClientFacingErrors)[number]

type ErrorWithGraphQLErrors = {
  graphQLErrors?: readonly { extensions?: Record<string, unknown> | undefined }[]
}

export const getGraphQLDomainError = (
  error: ErrorWithGraphQLErrors | undefined
): GraphQLDomainErrorName | undefined => {
  const domainError = error?.graphQLErrors?.[0]?.extensions?.['domainError']
  return graphQLClientFacingErrors.find(name => name === domainError)
}
